export default __webpack_public_path__ + "static/media/home-bg.719f7fd4.png";